module.exports = __webpack_public_path__ + "static/media/videobienvenidabootcamp1.04733e3e.mp4";